import React, { useEffect, useState } from 'react';



import GoHighLevel from '../../assets/img/GoHighLevel.png';
import asanaIcon from '../../assets/img/integrations/asana.svg';
import clickupIcon from '../../assets/img/integrations/clickup.svg';
import googleCalendarIcon from '../../assets/img/integrations/google-calendar.svg';
import gustoIcon from '../../assets/img/integrations/gusto.svg';
import jiraIcon from '../../assets/img/integrations/jira.svg';
import outlookCalendarIcon from '../../assets/img/integrations/outlook-calendar.svg';
import slackIcon from '../../assets/img/integrations/slack.svg';
import trelloIcon from '../../assets/img/integrations/trello.svg';
// Import existing integration icons
import xeroIcon from '../../assets/img/integrations/xero.svg';
import zapierIcon from '../../assets/img/integrations/zapier.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import SearchWithButton from '../../components/Search/SearchWithButton';
import { TabButton, TabButtonContainer } from '../../styledComponents/buttons';
import { CommonText, ContainerNew, FilterLabel, HeaderContainer, InputWithLabelSection, PageTitle } from '../../styledComponents/common';
import { ActionDropDown, AllIntegrationsContainer, AllIntegrationsDiv, BoldText, CardIcon, ConnectButton, ConnectText, HeaderText, Integration, IntegrationCard, IntegrationCardContainer, IntegrationsTableHeader, IntegrationsTableRow, IntegrationsTableView, NormalText, PointerText, SemiText, UpcomingBadge } from '../../styledComponents/integrations';
import { TabLeftGrid } from '../../styledComponents/members';
import { AuthHandler } from './integrationHandler/authHandler/authHandlerService';


// Update integration data to use local assets and add hidden property
const integrationsData = [
  {
    name: "Xero",
    icon: xeroIcon,
    path: "/user/integrations/xero/setup",
    upcoming: true,
    disabled: true,
    hidden: false,
  },
  {
    name: "Gusto",
    icon: gustoIcon,
    path: "/user/integrations/gusto/setup",
    upcoming: true,
    disabled: true,
    hidden: false,
  },
  {
    name: "Google Calendar",
    icon: googleCalendarIcon,
    path: "/user/integrations/google-calendar/setup",
    upcoming: true,
    disabled: true,
    hidden: false,
  },
  {
    name: "Outlook Calendar",
    icon: outlookCalendarIcon,
    path: "/user/integrations/outlook-calendar/setup",
    upcoming: true,
    disabled: true,
    hidden: false,
  },
  // Other integrations hidden by default
  {
    name: "HighLevel",
    icon: GoHighLevel,
    path: "/user/ghl-settings/",
    upcoming: true,
    disabled: false,
    hidden: true,
  },
  {
    name: "ClickUp",
    icon: clickupIcon,
    path: "/user/integrations/clickup/setup",
    upcoming: true,
    disabled: true,
    hidden: true,
  },
  {
    name: "Trello Power-Up",
    icon: trelloIcon,
    path: "https://trello.com/power-ups/615d5b18dd889573e477dcdc/trello-time-tracking-by-apploye",
    upcoming: false,
    disabled: false,
    isExternal: true,
    hidden: true,
  },
  {
    name: "Asana",
    icon: asanaIcon,
    path: "/user/integrations/asana/setup",
    upcoming: false,
    disabled: false,
    hidden: true,
  },
  {
    name: "Slack",
    icon: slackIcon,
    path: "/user/integrations/slack/setup",
    upcoming: false,
    disabled: false,
    hidden: true,
  },
  {
    name: "Zapier",
    icon: zapierIcon,
    path: "/user/integrations/zapier/setup",
    upcoming: false,
    disabled: false,
    hidden: true,
  },
  {
    name: "Jira Software",
    icon: jiraIcon,
    path: "/user/integrations/jira/setup",
    upcoming: false,
    disabled: false,
    hidden: true,
  },
];

const handleAuthFlow = (stepsData, otherData) => {
  const authHandler = new AuthHandler(stepsData, otherData);

  authHandler.init();
  // authHandler.run();
};

// Reusable Integration Card Component matching Figma design
const SingleIntegrationCard = props => {
  const {
    integration,
    history,
    selectedOrganization,
    connectIntegration,
    handleViewDetails,
  } = props;

  const handleClick = () => {
    if (integration.disabled) return;
    
    if (integration.isExternal && integration.path) {
      // Open external links in new tab
      window.open(integration.path, '_blank');
    } else if (integration.path) {
      history.push(integration.path);
    } else if (integration.is_installed) {
      handleViewDetails(integration.id);
    } else {
      connectIntegration(integration);
    }
  };

  return (
    <IntegrationCard>
      {integration.upcoming && <UpcomingBadge>Upcoming</UpcomingBadge>}
      <CardIcon src={integration.icon} alt={`${integration.name}Icon`} />
      <CommonText
        fontWeight="700"
        margin="20px 0 0 0"
        fontSize="16px"
        style={{ color: '#000e2a', fontFamily: 'Mona Sans, sans-serif' }}
      >
        {integration.name}
      </CommonText>
      <ConnectButton
        disabled={integration.disabled}
        onClick={handleClick}
      >
        Configure
      </ConnectButton>
    </IntegrationCard>
  );
};

const AllIntegrations = props => {
  const { history, integrations, enabledIntegrations, selectedOrganization } =
    props;

  const connectIntegration = integration => {
    // const { route } = integration;
    // if (route) {
    //   if (route.isLink) {
    //     window.open(route.pathname, "_blank");
    //   }
    // } else {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      integration.id &&
      integration.frontend_steps &&
      integration.frontend_steps.length > 0
    ) {
      handleAuthFlow(integration.frontend_steps, {
        organization_id: selectedOrganization.id,
        integration_id: integration.id,
      });
    }
    // }
  };

  const handleViewDetails = integrationId => {
    if (enabledIntegrations && enabledIntegrations.length > 0) {
      enabledIntegrations.some(item => {
        if (item.integration_id === integrationId) {
          history.push({
            pathname: `/user/integrations/${item.id}/details`,
            state: {
              enabledIntegration: {
                ...item,
              },
            },
          });
          return true;
        }
        return false;
      });
    }
  };

  return (
    <AllIntegrationsContainer>
      <AllIntegrationsDiv>
        {integrations &&
          integrations.map((integration, index) => (
            <React.Fragment key={index}>
              <SingleIntegrationCard
                integration={integration}
                history={history}
                selectedOrganization={selectedOrganization}
                handleViewDetails={handleViewDetails}
                connectIntegration={connectIntegration}
              />
            </React.Fragment>
          ))}
      </AllIntegrationsDiv>
      {/* <CommonColorButton padding="13px 25px">
          All Integrations
        </CommonColorButton> */}
    </AllIntegrationsContainer>
  );
};
const ActivatedIntegrations = props => {
  return null;
};

const IntegrationsNew = props => {
  const [selectedTab, setSelectedTab] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const {
    history,
    getAllIntegrationsList,
    allIntegrationsList,
    getEnabledIntegrationsList,
    enabledIntegrationsList,
    isLoading,
    selectedOrganization,
  } = props;

  const connectIntegration = integration => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      integration.id &&
      integration.frontend_steps &&
      integration.frontend_steps.length > 0
    ) {
      handleAuthFlow(integration.frontend_steps, {
        organization_id: selectedOrganization.id,
        integration_id: integration.id,
      });
    }
  };

  const handleViewDetails = integrationId => {
    if (enabledIntegrationsList && enabledIntegrationsList.length > 0) {
      enabledIntegrationsList.some(item => {
        if (item.integration_id === integrationId) {
          history.push({
            pathname: `/user/integrations/${item.id}/details`,
            state: {
              enabledIntegration: {
                ...item,
              },
            },
          });
          return true;
        }
        return false;
      });
    }
  };

  // useEffect(() => {
  //   if (selectedOrganization && selectedOrganization.id) {
  //     const payload = {
  //       organization_id: selectedOrganization.id,
  //     };
  //     getAllIntegrationsList(payload);
  //     getEnabledIntegrationsList(payload);
  //   }
  // }, [selectedOrganization]);

  const onTabSelect = value => {
    setSearchTerm('');
    setSelectedTab(value);
  };

  return (
    <div className="content">
      <ContainerNew>
        <PageTitle>Integrations</PageTitle>
      {/* <HeaderContainer>
        <TabLeftGrid columns="auto 280px">
          <InputWithLabelSection>
            <FilterLabel>Type</FilterLabel>
            <TabButtonContainer>
              <TabButton
                index="all"
                selected={selectedTab}
                onClick={() => onTabSelect("all")}
              >
                All Integrations
              </TabButton>
              <TabButton
                index="activated"
                selected={selectedTab}
                onClick={() => onTabSelect("activated")}
              >
                Activated Integrations
              </TabButton>
            </TabButtonContainer>
          </InputWithLabelSection>
          <SearchWithButton
            itemName="Integration"
            searchTermName="integration name"
          />
        </TabLeftGrid>
      </HeaderContainer> */}
      {/* {selectedTab && selectedTab === "all" ? (
        <AllIntegrations history={history} />
      ) : (
        <ActivatedIntegrations />
      )} */}
      {/* {isLoading ? (
        <ComponentCircleLoader />
      ) : (
        <AllIntegrations
          history={history}
          integrations={allIntegrationsList}
          enabledIntegrations={enabledIntegrationsList}
          selectedOrganization={selectedOrganization}
        />
      )} */}

      <IntegrationCardContainer>
        {integrationsData
          .filter(integration => !integration.hidden)
          .map((integration, index) => (
            <SingleIntegrationCard
              key={index}
              integration={integration}
              history={history}
              selectedOrganization={selectedOrganization}
              connectIntegration={connectIntegration}
              handleViewDetails={handleViewDetails}
            />
          ))}
      </IntegrationCardContainer>
      </ContainerNew>
      
    </div>
  );
};

export default IntegrationsNew;